import React from 'react';
import { childShareUrl } from '../../lib/share/childAppUrl';

// Import CTAs shown to unauthenticated visitors on the (parent-app)
// share landing page. A share link always points at the parent app, but
// the recipient may be a parent or a student, and the two import into
// different places:
//   - Parent  -> sign in here; the landing lets them pick which child to
//     import into and auto-resumes the import after the sign-in round-trip
//     (see onParentSignIn on ShareLandingPage).
//   - Student -> hand off to the student app's own /share/<token> landing,
//     which signs the student in and imports into their own account.
//
// The student hand-off is a real cross-origin navigation (the two apps
// are separate hosts in prod), so it must be a plain <a>, not a router
// push — react-router cannot navigate across origins.
const RolePicker = ({ token, onParentSignIn }) => {
    return (
        <div className="flex flex-col items-stretch gap-2 sm:flex-row sm:justify-end">
            <button
                type="button"
                className="bg-blue-500 text-white py-2 px-4 rounded text-center"
                onClick={onParentSignIn}>
                Import as a parent
            </button>
            <a
                href={childShareUrl(token)}
                className="border border-blue-500 text-blue-600 hover:bg-blue-50 py-2 px-4 rounded text-center">
                Import as a student
            </a>
        </div>
    );
};

export default RolePicker;
